import React from 'react';
import styles from './ViewArchivesLink.module.css';

interface ViewArchivesLinkProps {
  gameId: string;
  signatureColor: string;
  onArchivesClick?: () => void;
}

export function ViewArchivesLink({ gameId, signatureColor, onArchivesClick }: ViewArchivesLinkProps) {
  const handleClick = () => {
    if (onArchivesClick) {
      onArchivesClick();
    } else {
      // Fallback: warn in dev if no handler provided (should not happen in production)
      if (import.meta.env.DEV) {
        console.warn('No onArchivesClick handler provided for game:', gameId);
      }
    }
  };

  return (
    <button
      type="button"
      onClick={handleClick}
      className={styles.link}
      style={{ color: signatureColor, WebkitTextFillColor: signatureColor }}
    >
      <span>View Archives</span>
      <span className={styles.arrow}>→</span>
    </button>
  );
}